// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
/* eslint-disable no-underscore-dangle */
import { ua, labels as utilLabels } from '@seedplanner/shared-utils';
import { routes } from '@seedplanner/shared-web';
import { createApolloClient } from './createApolloClient';
import { createAppContext } from './createAppContext';
import { renderApp } from './renderApp';

export const render = () => {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const currentWindow = window as any;

  const userAgent = currentWindow.__USER_AGENT__;
  const labels = {
    ...ua.convertLabels(userAgent),
    [utilLabels.APP_VERSION]: currentWindow.__APP_VERSION__,
  };

  // Using session storage to store current apollo state for when user
  // keeps tab open for a while. Tab will go to background. When it's opened again
  // the browser will re-run render using potentially old data. Data in HTML
  // will be different from stale data in window.__APOLLO_STATE__. So save
  // Apollo state in session storage and use that to hydrate the client if it exists.
  // Session storage should only exist if they leave tab but don't close tab
  // const apolloStateWindow = currentWindow.__APOLLO_STATE__;
  // const APOLLO_STATE_SESSION_KEY = 'APOLLO_STATE';
  // const maybeApolloSessionState = sessionStorage.getItem(APOLLO_STATE_SESSION_KEY);
  // const apolloState = maybeApolloSessionState ? JSON.parse(maybeApolloSessionState) : apolloStateWindow;
  const apolloState = currentWindow.__APOLLO_STATE__;

  const apolloClient = createApolloClient({
    endpoint: routes.GRAPHQL,
    labels,
    apolloState: apolloState,
  });

  // let isUnloading = false;
  // document.addEventListener('visibilitychange', () => {
  //   if (document.visibilityState === 'hidden' && !isUnloading) {
  //     sessionStorage.setItem(APOLLO_STATE_SESSION_KEY, JSON.stringify(apolloClient.extract()));
  //   }
  // });
  // window.addEventListener('pagehide', () => {
  //   isUnloading = true;
  //   sessionStorage.removeItem(APOLLO_STATE_SESSION_KEY);
  // });
  // window.addEventListener('beforeunload', () => {
  //   isUnloading = true;
  // });

  const appContext = createAppContext({
    environment: currentWindow.__ENV__,
    css: currentWindow.__CSS__,
    nonce: currentWindow.__NONCE__,
    options: currentWindow.__OPTIONS__,
    userAgent,
  });
  const initialLocalState = currentWindow.__INITIAL_LOGGED_IN_STATE__;
  const intitialUserState = currentWindow.__INITIAL_USER_STATE__;

  renderApp(appContext, apolloClient, initialLocalState, intitialUserState);
};
